import { useEffect, useState } from 'react';
import { __ } from 'i18n/index';
import { sprintf } from 'i18n/format';

// How long a lobby's search stays open, ticking each second: "11:42 left",
// or the format given ("Search closes in %s").
function formatRemaining(seconds) {
	const safe = Math.max(0, Math.floor(seconds));
	return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, '0')}`;
}

export default function LobbyClock({ match, format = null }) {
	const [, setTick] = useState(0);
	useEffect(() => {
		const interval = setInterval(() => setTick((tick) => tick + 1), 1000);
		return () => clearInterval(interval);
	}, []);
	const remaining = typeof match.getSearchTimeRemaining === 'function' ? match.getSearchTimeRemaining() : null;
	if(remaining === null || remaining === undefined || remaining === true) {
		return null;
	}
	const time = formatRemaining(remaining);
	return format ? sprintf(format, [time]) : __('%s left', time);
}
